// extracted by mini-css-extract-plugin
export var active = "_g6-7";
export var blink = "_g6-8";
export var dropDownSelector = "_g6-4";
export var dropDownWrapper = "_g6-3";
export var fakeCursor = "_g6-6";
export var fontSizeButton = "_g6-9";
export var formQuillEditor = "_g6-0";
export var pressed = "_g6-a";
export var qlBlank = "_g6-1";
export var textFormattingToolbar = "_g6-2";
export var textToolbarOption = "_g6-5";